import React from 'react';
import './LOFAScheduleEditMode.scss';
import { useStoreContext } from '../../../App/StoreProvider';
import {
    GetLofaSchedule_getLofaSchedule as LofaScheduleSummaryData,
    GetLofaSchedule_getLofaSchedule_jobSummaries as LoadFacilityDetailData,
    GetAllLofas,
} from '../../../../types/schemaTypes';
import * as LOFAScheduleEditActions from '../../../../store/actions/lofaScheduleEdit';
import LOFAScheduleDetailRow from '../LOFAScheduleDetailRow';
import LofaScheduleFacilityRow from '../LOFAScheduleFacilityRow';
import AddFacility from '../AddFacility';
import { GET_ALL_LOFAS } from '../../../../graphql/client/queries';
import { useQuery } from '@apollo/client/react';
import { useAuthContext } from '../../../Auth/AuthProvider';
import { PermissionEnum } from '../../../../types/PermissionEnum';
import {v4 as uuid} from 'uuid';

interface LOFAScheduleEditModeProps {
    lofaScheduleSummaryList: LofaScheduleSummaryData[];
}

const LOFAScheduleEditMode = ({ lofaScheduleSummaryList }: LOFAScheduleEditModeProps): React.ReactElement | null => {
    const [state, dispatch] = useStoreContext();
    const { lofaScheduleEdit } = state;
    const { data } = useQuery<GetAllLofas>(GET_ALL_LOFAS);
    const isDeleteEnabled = useAuthContext().userHasPermission(PermissionEnum.DeleteLOFASchedule);

    if (lofaScheduleEdit.currentValues.length < 1 && lofaScheduleSummaryList.length > 0) {
        dispatch(LOFAScheduleEditActions.setInitialData(lofaScheduleSummaryList, []));
    }

    const isFacilityItemDeleted = (
        lofaItem: LofaScheduleSummaryData,
        facilityItem: LoadFacilityDetailData,
    ): boolean => {
        const existingFacilityItems = lofaScheduleEdit.toBePosted.filter(
            item => item.proppantId === lofaItem.proppantId,
        )[0];
        let existingFacilityItem;
        if (existingFacilityItems) {
            existingFacilityItem =
                existingFacilityItems.jobSummaries &&
                existingFacilityItems.jobSummaries.filter(it => it.id === facilityItem.id)[0];
        }
        if (existingFacilityItem) {
            return existingFacilityItem && existingFacilityItem.isDeleted === true;
        }
        return false;
    };

    const listFacilities = (lofaDetail: LofaScheduleSummaryData | null): (React.ReactElement | undefined)[] | undefined => {
        if (lofaDetail && lofaDetail.jobSummaries && lofaDetail.jobSummaries.length !== 0) {
            let proppantTotalVolume = 0;
            lofaDetail.jobSummaries.forEach((facilityItem: LoadFacilityDetailData | null) => {
                if (
                    proppantTotalVolume === 0 &&
                    facilityItem &&
                    facilityItem.totalVolume &&
                    facilityItem.totalVolume !== 0
                ) {
                    proppantTotalVolume = facilityItem.totalVolume;
                }
            });
            return lofaDetail.jobSummaries.map((facilityItem: LoadFacilityDetailData | null, facilityIndex: number):
                | React.ReactElement
                | undefined => {
                if (
                    data &&
                    facilityItem !== null &&
                    facilityIndex === 0 &&
                    !isFacilityItemDeleted(lofaDetail, facilityItem)
                ) {
                    return (
                        <LofaScheduleFacilityRow
                            key={facilityItem.id || uuid()}
                            lofaDetail={lofaDetail}
                            facility={facilityItem}
                            totalVolume={proppantTotalVolume}
                            lofas={data.getAllLofas}
                            isDeleteEnabled={isDeleteEnabled}
                        />
                    );
                } else if (
                    data &&
                    facilityItem !== null &&
                    facilityIndex !== 0 &&
                    !isFacilityItemDeleted(lofaDetail, facilityItem)
                ) {
                    return (
                        <AddFacility
                            key={facilityItem.id || uuid()}
                            lofaDetail={lofaDetail}
                            facility={facilityItem}
                            totalVolume={proppantTotalVolume}
                            lofas={data.getAllLofas}
                            isDeleteEnabled={isDeleteEnabled}
                        />
                    );
                }
                return undefined;
            });
        }

        return undefined;
    };

    return (
        <div>
            {lofaScheduleEdit.currentValues.map((lofaDetail: LofaScheduleSummaryData | null, i: number):
                | React.ReactElement
                | undefined => {
                if (lofaDetail !== null) {
                    const lofaSummaryDetail = lofaScheduleSummaryList.filter(
                        it => it.proppantId === lofaDetail.proppantId,
                    )[0];
                    return (
                        <div
                            key={lofaDetail.proppantId || uuid()}
                            className={i % 2 ? 'LOFASchedule-Detail-Odd-Row2' : 'LOFASchedule-Detail-Even-Row2'}
                        >
                            <div className="LOFAScheduleEdit-Container">
                                <LOFAScheduleDetailRow lofaScheduleDetail={lofaDetail} />
                                <div className="LOFAScheduleEdit-FacilitiesContainer">{listFacilities(lofaDetail)}</div>
                            </div>
                            <div className="LOFASchedule-Add2 Row">
                                <div className="LOFASchedule-EditLofaDetail">{''}</div>
                                <div className="LOFASchedule-EditDetail">{''}</div>
                                <div className="LOFASchedule-EditDetail">{''}</div>
                                <div className="LOFASchedule-EditDetail-Row">
                                    <div
                                        className="LOFASchedule-EditDetail-AddFacility"
                                        onClick={() =>
                                            dispatch(LOFAScheduleEditActions.addFacility(lofaDetail, lofaSummaryDetail))
                                        }
                                    >
                                        <i className="material-icons LOFASchedule-Edit-Icon">add_circle</i>
                                        <span className="LOFASchedule-Edit-Link">Add Facility</span>
                                    </div>
                                </div>
                                <div className="LOFASchedule-EditDetail">{''}</div>
                                <div className="LOFASchedule-EditDetail">{''}</div>
                            </div>
                        </div>
                    );
                }
                return undefined;
            })}
        </div>
    );
};

export default LOFAScheduleEditMode;

